import React, { useState } from "react";
import GlobalTabContent from "./tabs/GlobalTabContent";
import LocalTabContent from "./tabs/LocalTabContent";
import FormulaTabContent from "./tabs/FormulaTabContent";
import ConditionTabContent from "./tabs/ConditionTabContent";
import RangeTabContent from "./tabs/RangeTabContent";


const ParameterTabs = () => {
  const [activeTab, setActiveTab] = useState("global");

  const renderContent = () => {
    switch (activeTab) {
      case "global":
        return <GlobalTabContent />;
      case "local":
        return <LocalTabContent />;
      case "formula":
        return <FormulaTabContent />;
    case "condition":
  return <ConditionTabContent />;
case "range":
  return <RangeTabContent />;

      default:
        return null;
    }
  };

  return (
    <div>
      <div style={tabRowStyle}>
        <button onClick={() => setActiveTab("global")} style={btn(activeTab === "global")}>Global</button>
        <button onClick={() => setActiveTab("local")} style={btn(activeTab === "local")}>Local</button>
        <button onClick={() => setActiveTab("formula")} style={btn(activeTab === "formula")}>Formula</button>
        <button onClick={() => setActiveTab("condition")} style={btn(activeTab === "condition")}>Condition</button>
<button onClick={() => setActiveTab("range")} style={btn(activeTab === "range")}>Range</button>

      </div>
      <div>{renderContent()}</div>
    </div>
  );
};

const tabRowStyle = {
  display: "flex",
  gap: "15px",
  marginBottom: "10px",
};

const btn = (active) => ({
  padding: "4px 12px",
  backgroundColor: active ? "#00bcd4" : "#2d2d2d",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "4px",
  cursor: "pointer",
});

export default ParameterTabs;
